import { Command } from "@ckeditor/ckeditor5-core";

export default class InsertBootstrapIconCommand extends Command {
    execute({ iconClass }) {
        const editor = this.editor;

        editor.model.change((writer) => {
            // Ajoute un caractère invisible pour que l’élément <i> ne soit pas supprimé à la sauvegarde
            // et pour que l'icône soit visible dans l'éditeur. Sinon ck supprime l'élément vide.
            const html = `<i class="${iconClass}"></i>`;

            console.log("Inserting Bootstrap icon commande:", html);

            const viewFragment = editor.data.processor.toView(html);
            const modelFragment = editor.data.toModel(viewFragment);

            editor.model.insertContent(modelFragment);
        });
    }

    refresh() {
        this.isEnabled = true;
    }
}
